import { Component, OnInit, HostListener } from '@angular/core';
import {ListenActionForEvaluationService} from "@rex/evaluations/services/listen-action-for-evaluation.service";
import { IntercomService } from '@rex/services/intercom.service';
import { OnIdentifyEffects } from '@ngrx/effects';
import { UpdateService } from '@rex/UpdateService';

@Component({
  selector: 'rex-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private previousWidth!: number;
  private resizeTimeout: any;
  /**
   * Create a new instance.
   */
  constructor(
    private swUpdate: UpdateService,
    private listenActionForEvaluationService: ListenActionForEvaluationService
  ) {
    this.swUpdate.checkForUpdates();
    this.listenActionForEvaluationService.runEvaluationRequestActions();
  }

  ngOnInit() {
    this.previousWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    clearTimeout(this.resizeTimeout);

    this.resizeTimeout = setTimeout(() => {
      const currentWidth = window.innerWidth;
      const crossedBreakpoint = (
        (this.previousWidth < 992 && currentWidth >= 992) ||
        (this.previousWidth >= 992 && currentWidth < 992)
      );

      if (crossedBreakpoint) {
        window.location.reload();
      }

      this.previousWidth = currentWidth;
    }, 300); // debounce: czekaj 300ms po resize
  }
}

